import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[70vh] text-center px-4">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 text-3xl mb-5">
        <i className="ri-compass-3-line"></i>
      </span>
      <h1 className="font-heading font-extrabold text-3xl md:text-4xl text-foreground-950">
        404
      </h1>
      <p className="mt-3 text-foreground-700 font-medium">抱歉，你访问的页面不存在</p>
      <p className="mt-1 text-sm text-foreground-500 font-mono break-all">{location.pathname}</p>
      <p className="mt-4 text-sm text-foreground-500">
        页面可能已被移动或链接有误，试试回到首页继续浏览吧
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          返回首页
        </Link>
        <Link
          to="/search"
          className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 text-sm font-label hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          去搜索影视
        </Link>
      </div>
    </div>
  );
}